class SearchDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#SearchDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const searchLink = document.querySelector('#search-toggle-open');
    if (!searchLink) return;

    searchLink.setAttribute('role', 'button');
    searchLink.setAttribute('aria-haspopup', 'dialog');
    searchLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(searchLink);
    });
    searchLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(searchLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const searchDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (searchDrawerNote && !searchDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(searchDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('SearchDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(searchDrawerNote) {
    searchDrawerNote.setAttribute('role', 'button');
    searchDrawerNote.setAttribute('aria-expanded', 'false');

    if (searchDrawerNote.nextElementSibling.getAttribute('id')) {
      searchDrawerNote.setAttribute('aria-controls', searchDrawerNote.nextElementSibling.id);
    }

    searchDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    searchDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#SearchDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'search-drawer',
        selector: '#SearchDrawer',
      },
      {
        id: 'search-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('search-drawer', SearchDrawer);

class SearchDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'SearchDrawer',
        section: 'search-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'search-icon-bubble',
        section: 'search-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('search-drawer-items', SearchDrawerItems);
